// Human labels + display order for the agent-chains allowlist.
//
// This mirrors AGENT_CHAINS in server/src/services/AgentService.ts.
// Chains are a small, curated set (unlike capabilities which the
// server can grow at will), so we hardcode the list client-side to
// avoid a round-trip per page load. Adding a chain = add a key here
// AND in the server allowlist; the two lists stay in sync manually.
// Zod on the server rejects unknown keys, so a client/server skew
// surfaces as a 400 at PATCH time — not a silent drop.

export const AGENT_CHAINS = ['klv', 'eth', 'btc', 'sol', 'base'] as const;

export type AgentChain = (typeof AGENT_CHAINS)[number];

export const AGENT_CHAIN_LABELS: Record<string, string> = {
  klv: 'KLV',
  eth: 'ETH',
  btc: 'BTC',
  sol: 'SOL',
  base: 'Base',
};

export function labelForChain(key: string): string {
  return AGENT_CHAIN_LABELS[key] ?? key.toUpperCase();
}
